export class MailConfig {

    public  clientId: String = "";
    public  clientSecret: String = "";
    public  mailId: String = "";
    public  scope: String = "";
    public  tenantId: String = "";
    public  logLevel: String = "";
    public  apiBaseUrl: String = "";
}